// removed by extract-text-webpack-plugin
module.exports = {"save-container":"save-container___2r7qU","save":"save___2qwbN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemSave/ItemSaveIcon.scss
// module id = uHXy
// module chunks = 57